import React from 'react';
import { Card, Flex } from '@radix-ui/themes';

import { ActionNode, ActionType } from '../../../../types';
import { NodeContextMenu } from '../../ContextMenu';
import { WorkflowNodeProps } from '..';

import DefaultActionNode from './types/Default';
import DiscordMessageNode from './types/Discord';
import SlackMessageNode from './types/Slack';

const actionNodeComponentMap: Record<
  'default' | ActionType,
  React.ComponentType<any>
> = {
  default: DefaultActionNode,
  [ActionType.DiscordMessage]: (props) => <DiscordMessageNode {...props} />,
  [ActionType.SlackMessage]: (props) => <SlackMessageNode {...props} />,
  [ActionType.Email]: () => <div>EmailNode</div>,
  [ActionType.Contract]: () => <div>ContractNode</div>,
  [ActionType.Database]: () => <div>DatabaseNode</div>,
  [ActionType.Webhook]: () => <div>WebhookNode</div>,
};

const ActionNodeComponent = (props: WorkflowNodeProps<ActionNode>) => {
  const { id, data, onDelete } = props;
  console.log('ActionNode', data);

  const NodeComponent = actionNodeComponentMap[data.action.actionType];

  if (!NodeComponent) {
    return (
      <NodeContextMenu onDelete={() => onDelete(id)}>
        <Card style={{ width: '300px', border: '1px dashed orange' }}>
          <Flex align="center" justify="center" p="2">
            Unknown action type: {data.action.actionType}
          </Flex>
        </Card>
      </NodeContextMenu>
    );
  }

  return (
    <NodeContextMenu onDelete={() => onDelete(id)}>
      <NodeComponent {...props} onCancel={() => onDelete(id)} />
    </NodeContextMenu>
  );
};

export default ActionNodeComponent;
